import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { PERMISSION_HO_TEAM_ID } from 'src/app/handover-constants';
import { Handover } from 'src/app/interfaces/handover';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-home-content-sent-personal',
  templateUrl: './home-content-sent-personal.component.html',
  styleUrls: ['./home-content-sent-personal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HomeContentSentPersonalComponent implements OnInit {
  @Input() handoversSentPersonal: Handover[] | undefined;
  @Input() totalHandoversSentPersonal: number | undefined;
  @Input() searchSentPersonal: string | undefined;
  @Output() reloadSent = new EventEmitter<boolean>();
  @Output() eventShowSentPersonal = new EventEmitter<boolean>();
  @Output() handoversSentPersonalWithFilter = new EventEmitter<string>();

  canPermissionTeam = false;
  destinationLabel = 'Hacia';
  textSearch = '';

  constructor(private userService: UserService) {
    // Agrego esta linea para que Husky deje hacer commit y push.
  }

  ngOnInit(): void {
    this.canPermissionTeam = this.userService.hasPermission(
      PERMISSION_HO_TEAM_ID
    );
    this.textSearch = this.searchSentPersonal ? this.searchSentPersonal : '';
  }

  eventReload(reload: boolean) {
    this.reloadSent.emit(true);
  }
  showSentTeam() {
    this.eventShowSentPersonal.emit(false);
  }

  getHandoversHomeSentPersonalWithFilter(searchText: string): void {
    this.textSearch = searchText;
    this.handoversSentPersonalWithFilter.emit(searchText);
  }
}
